import React, { useState } from "react";
import "./ImportFromExcel.css";

const ImportFromExcel = ({ onFileUpload }) => {
  const [file, setFile] = useState(null);
  const [message, setMessage] = useState("");

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (!selectedFile) return;

    const allowedTypes = [
      "application/vnd.ms-excel",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    ];

    if (!allowedTypes.includes(selectedFile.type)) {
      setMessage("Please select a valid Excel file (.xls or .xlsx)");
      e.target.value = null;
      return;
    }

    setFile(selectedFile);
    setMessage("");
    if (onFileUpload) onFileUpload(selectedFile);
  };

  const handleSubmit = () => {
    if (!file) {
      setMessage("No file selected!");
      return;
    }

    setMessage(`File "${file.name}" ready for import`);
    setFile(null);
  };

  return (
    <div className="import-page">
      <div className="import-container">
        <h2>Import Excel File</h2>
        <p className="subtitle">
          Upload an Excel file (.xls or .xlsx) to import your data.
        </p>

        <label className="file-upload">
          <input
            type="file"
            accept=".xls,.xlsx"
            onChange={handleFileChange}
          />
          <span>
            {file ? file.name : "Click to select Excel file"}
          </span>
        </label>

        {message && (
          <p className={file ? "success" : "error"}>
            {message}
          </p>
        )}

        <button onClick={handleSubmit}>
          Import File
        </button>
      </div>
    </div>
  );
};

export default ImportFromExcel;